import React from 'react'
import { ToastProps } from './type'
import { getToastStyles } from './style'
import useTheme from '../../hooks/useTheme'
import { Typography } from '..'
import { TypographyVariant } from '../Typography/type'

const Toast: React.FC<ToastProps> = ({
    message,
    type = 'ERROR',
    position = 'BOTTOM',
    visible = true,
    className = '',
    dataTestId = ''
}) => {
    const theme = useTheme()
    const { containerStyle, toastStyle, textColor } = getToastStyles({
        theme,
        type,
        position,
        visible
    })

    if (!message || !visible) return null

    return (
        <div
            className={className}
            data-testid={dataTestId ? dataTestId : undefined}
            style={containerStyle}
        >
            <div style={toastStyle}>
                <Typography
                    variant={TypographyVariant.B2}
                    colorCode={textColor}
                >
                    {message}
                </Typography>
            </div>
        </div>
    )
}

export default Toast
